var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2856 11.1426H15.4284C14.955 11.1426 14.5713 11.5263 14.5713 11.9997V22.2854C14.5713 22.7587 14.955 23.1426 15.4284 23.1426H22.2856C22.7589 23.1426 23.1427 22.7587 23.1427 22.2854V11.9997C23.1427 11.5263 22.7589 11.1426 22.2856 11.1426Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2856 0.856934H15.4284C14.955 0.856934 14.5713 1.24069 14.5713 1.71408V5.15979C14.5713 5.63317 14.955 6.01693 15.4284 6.01693H22.2856C22.7589 6.01693 23.1427 5.63317 23.1427 5.15979V1.71408C23.1427 1.24069 22.7589 0.856934 22.2856 0.856934Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57122 0.856934H1.71408C1.24069 0.856934 0.856934 1.24069 0.856934 1.71408V11.9998C0.856934 12.4732 1.24069 12.8569 1.71408 12.8569H8.57122C9.0446 12.8569 9.42836 12.4732 9.42836 11.9998V1.71408C9.42836 1.24069 9.0446 0.856934 8.57122 0.856934Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57122 17.9824H1.71408C1.24069 17.9824 0.856934 18.3661 0.856934 18.8396V22.2853C0.856934 22.7586 1.24069 23.1424 1.71408 23.1424H8.57122C9.0446 23.1424 9.42836 22.7586 9.42836 22.2853V18.8396C9.42836 18.3661 9.0446 17.9824 8.57122 17.9824Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_1034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.e18ec18c8944d02e2de8c8ff9f767e2b.svg";
export { ForwardRef as ReactComponent };